module.exports = __webpack_public_path__ + "static/media/restaurant.9ee0b034.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/restaurant.svg
// module id = 1515
// module chunks = 0